import { render, staticRenderFns } from "./ModalDanger.vue?vue&type=template&id=114bea32&"
import script from "./ModalDanger.vue?vue&type=script&lang=js&"
export * from "./ModalDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports